<template>
  <div>
    <!-- 微商城 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
      <el-breadcrumb-item>活动详情</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="tab">
      <span
        v-for="(v,i) in tabBtn"
        :key="v.id"
        @click="tabTitle(i)"
        :class="activeIndex==i?'activeTab':''"
      >{{v.name}}</span>
    </div>

    <!-- 商品管理 -->
    <div v-if="activeIndex==0">
      <el-card>
        <div class="titleSear">
          <div>
            <el-input placeholder="手机号/订单号/凭证码"></el-input>
            <el-select v-model="value" clearable placeholder="全部分类">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="value" clearable placeholder="全部产品">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button>查询</el-button>
          </div>
          <div>
            <div>
              <el-button @click="addFn()">添加商品</el-button>
            </div>
            <div>
              <el-button>排序</el-button>
            </div>
            <div>
              <el-button>删除</el-button>
            </div>
          </div>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          key="one"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="序号" width="120"></el-table-column>
          <el-table-column prop="name" label="产品名称"></el-table-column>
          <el-table-column prop="address" label="微商城价"></el-table-column>
          <el-table-column prop="address" label="每日购买限制"></el-table-column>
          <el-table-column prop="address" label="每日已售"></el-table-column>
          <el-table-column prop="address" label="总购买限制"></el-table-column>
          <el-table-column prop="address" label="总已售"></el-table-column>
          <el-table-column prop="address" label="是否可退">
            <template>
              <img src="@/images/scenic/dhl.png" alt />
              <img src="@/images/scenic/xhh.png" alt />
            </template>
          </el-table-column>
          <el-table-column prop="address" label="首页是否显示">
            <template slot-scope="scope">
              <el-switch v-model="value3" active-color="#246DEB" inactive-color="#E5E5EA"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="微商城操作">
            <template>
              <el-button type="text" style="color: #E74C3C;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- 退票管理 -->
    <div v-if="activeIndex==1">
      <el-card>
        <el-row class="conentRow">
          <el-input placeholder="手机号/订单号/凭证码"></el-input>
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>

          <el-button class="conentBtn" type="primary">查询</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          key="two"
          style="width: 100%"
        >
          <el-table-column prop="name" label="订单号"></el-table-column>
          <el-table-column prop="name" label="微商城订单号"></el-table-column>
          <el-table-column prop="address" label="产品名称"></el-table-column>
          <el-table-column prop="address" label="订单总额"></el-table-column>
          <el-table-column prop="address" label="手机号"></el-table-column>
          <el-table-column prop="address" label="订单创建时间"></el-table-column>
          <el-table-column prop="address" label="退票状态">
            <template slot-scope="scope">
              <img src="@/images/scenic/wkp.png" alt />
              <img src="@/images/scenic/wqr.png" alt />
              <span style="margin-left:20px">{{scope.row.address}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="微商城操作">
            <template slot-scope="scope">
              <el-button type="text">确认打款</el-button>
              <el-button type="text" @click="tickInfoFn(scope.row)">订单详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- 退票管理结束 -->
    <!-- 订单列表开始 -->
    <div v-if="activeIndex==2">
      <el-card>
        <el-row class="conentRow">
          <el-input placeholder="手机号/订单号/凭证码"></el-input>
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="value" clearable placeholder="全部分销商">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-model="value" clearable placeholder="全部验票查询">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary">查询</el-button>
          <el-button class="conentBtn1" type="primary">导出报表</el-button>
          <el-button class="conentBtn1" type="primary">核销报表</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          key="three"
          style="width: 100%"
        >
          <el-table-column prop="name" label="微商城订单号"></el-table-column>
          <el-table-column prop="address" label="雪务通订单号"></el-table-column>
          <el-table-column prop="address" label="下单时间"></el-table-column>
          <el-table-column prop="address" label="数量"></el-table-column>
          <el-table-column prop="address" label="金额"></el-table-column>
          <el-table-column prop="address" label="用户名"></el-table-column>
          <el-table-column prop="address" label="电话"></el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共几条记录，</span>
          <span class="demonstration">当前显示第几页</span>
          <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- 订单列表结束 -->
    <!-- 样式设置开始 -->
    <div v-if="activeIndex==3">
      <el-card style="width:100%;height:740px">
        <div class="typeSet">
          <div class="titleTop">给商城小程序设置模式</div>
          <div class="styleSet">
            <div>
              <div>
                <img src="@/images/scenic/br.png" alt />
              </div>
              <el-radio v-model="radio" label="1">白日模式</el-radio>
            </div>
            <div>
              <div>
                <img src="@/images/scenic/ht.png" alt />
              </div>
              <el-radio v-model="radio" label="2">暗黑模式</el-radio>
            </div>
          </div>
          <div class="btn">
            <el-button>删除</el-button>
            <el-button class="btnL">保存</el-button>
          </div>
        </div>
      </el-card>
    </div>
    <!-- 样式设置结束 -->

    <!-- 商品管理添加商品开始 -->
    <wShoppingDialog v-if="addshopvisible" ref="addshopDialog"></wShoppingDialog>
    <!-- 商品管理添加商品结束 -->
    <!-- 退票管理订单详情开始 -->
    <wShoppingDialog v-if="tickInfovisible" ref="tickInfoDialog"></wShoppingDialog>
    <!-- 退票管理订单详情结束 -->
  </div>
</template>

<script>
import wShoppingDialog from "./dialog/wShoppingDialog.vue";
export default {
  components: {
    wShoppingDialog
  },
  data() {
    return {
      addshopvisible: false, // 商品管理添加商品
      tickInfovisible: false, // 退票管理订单详情
      radio: "",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "57674"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "2464634"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "43434"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "1345"
        }
      ],
      tabBtn: [
        {
          id: 1,
          name: "商品管理"
        },
        {
          id: 2,
          name: "退票管理"
        },
        {
          id: 3,
          name: "订单列表"
        },
        {
          id: 4,
          name: "样式设置"
        }
      ],
      upOption: [
        {
          id: 1,
          value: "是"
        },
        {
          id: 2,
          value: "否"
        }
      ],
      value: "",
      activeIndex: "", // 选中tab
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      value3: true,
      multipleSelection: []
    };
  },
  methods: {
    // 商品管理添加商品
    addFn() {
      this.addshopvisible = true;
      this.$nextTick(() => {
        this.$refs.addshopDialog.addShop();
      });
    },
    // 退票管理订单详情
    tickInfoFn(row) {
      this.tickInfovisible = true;
      this.$nextTick(() => {
        this.$refs.tickInfoDialog.tickInfo(row);
      });
    },
    tabTitle(index) {
      // console.log(index);
      this.activeIndex = index;
      console.log(this.activeIndex);
    },
    // 商品管理全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.typeSet {
  .titleTop {
    margin-bottom: 15px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .btn {
    width: 100%;
    text-align: center;
    margin-top: 150px;
    .el-button {
      width: 100px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
      margin-right: 20px;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
  }
  .styleSet {
    display: flex;
    img {
      width: 300px;
      height: 432px;
      margin-right: 20px;
    }
    .el-radio {
      width: 300px;
      text-align: center;
      margin-top: 20px;
    }
  }
}
.titleSear {
  margin-bottom: 20px;
  display: flex;
  > div:nth-child(1) {
    width: 60%;
    .el-input {
      width: 220px;
      margin-right: 20px;
    }
    .el-select {
      width: 220px;
      margin-right: 20px;
    }
    .el-button {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
      margin-right: 20px;
    }
  }
  > div:nth-child(2) {
    width: 40%;
    display: flex;
    justify-content: flex-end;
    > div:nth-child(1) {
      .el-button {
        width: 110px;
        background: #ffffff;
        border: 1px solid #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #246deb;
        margin-right: 20px;
      }
    }
    > div:nth-child(2) {
      .el-button {
        width: 100px;
        background: #ffffff;
        border: 1px solid #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #246deb;
        margin-left: 20px;
      }
    }
    > div:nth-child(3) {
      .el-button {
        width: 100px;
        background: #ffffff;
        border: 1px solid #e74c3c;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #e74c3c;
        margin-left: 20px;
      }
    }
  }
}
.conentRow {
  display: flex;
  margin-bottom: 20px;
  .el-date-editor {
    margin-right: 20px;
  }
  .el-input {
    width: 220px;
    margin-right: 20px;
  }
  .el-select {
    width: 220px;
    margin-right: 20px;
  }
  .conentBtn {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    border: none;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
  .conentBtn1 {
    width: 120px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    border: none;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
}

.qxsq {
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 30px auto 20px;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}

.tab {
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 0px 0px 4px 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 20px;
  }
}
// /deep/.el-dialog__header {
//   height: 60px;
//   line-height: 60px;
//   padding: 0;
// }

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>